module.exports = __webpack_public_path__ + "img/NewsCenterDetails3_pic5.b2c46044.png";